/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { PermalinkViewContainer_settings$ref } from "./PermalinkViewContainer_settings.graphql";
import { StreamContainer_settings$ref } from "./StreamContainer_settings.graphql";
export type RefreshSettingsFetchQueryVariables = {
    readonly storyID: string;
};
export type RefreshSettingsFetchQueryResponse = {
    readonly settings: {
        readonly " $fragmentRefs": StreamContainer_settings$ref & PermalinkViewContainer_settings$ref;
    };
    readonly story: {
        readonly closedAt: string | null;
        readonly isClosed: boolean;
    } | null;
};
export type RefreshSettingsFetchQuery = {
    readonly response: RefreshSettingsFetchQueryResponse;
    readonly variables: RefreshSettingsFetchQueryVariables;
};



/*
query RefreshSettingsFetchQuery(
  $storyID: ID!
) {
  settings {
    ...StreamContainer_settings
    ...PermalinkViewContainer_settings
    id
  }
  story(id: $storyID) {
    closedAt
    isClosed
    id
  }
}

fragment StreamContainer_settings on Settings {
  reaction {
    sortLabel
  }
  ...PostCommentFormContainer_settings
  ...UserBoxContainer_settings
  ...CommunityGuidelinesContainer_settings
  ...SuspendedInfoContainer_settings
  ...AnnouncementContainer_settings
}

fragment PermalinkViewContainer_settings on Settings {
  ...ConversationThreadContainer_settings
  ...ReplyListContainer1_settings
  ...UserBoxContainer_settings
}

fragment ConversationThreadContainer_settings on Settings {
  ...CommentContainer_settings
  ...LocalReplyListContainer_settings
  ...UserTagsContainer_settings
}

fragment ReplyListContainer1_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListContainer2_settings
  ...CommentContainer_settings
}

fragment UserBoxContainer_settings on Settings {
  auth {
    integrations {
      local {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      oidc {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      google {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      facebook {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
    }
  }
}

fragment ReplyListContainer2_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReplyListContainer3_settings
  ...CommentContainer_settings
}

fragment CommentContainer_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReactionButtonContainer_settings
  ...ReplyCommentFormContainer_settings
  ...EditCommentFormContainer_settings
  ...UserTagsContainer_settings
}

fragment ReactionButtonContainer_settings on Settings {
  reaction {
    label
    labelActive
    icon
    iconActive
  }
}

fragment ReplyCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
}

fragment EditCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
}

fragment UserTagsContainer_settings on Settings {
  staff {
    label
  }
}

fragment ReplyListContainer3_settings on Settings {
  disableCommenting {
    enabled
  }
  ...LocalReplyListContainer_settings
  ...CommentContainer_settings
}

fragment LocalReplyListContainer_settings on Settings {
  ...CommentContainer_settings
}

fragment PostCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
}

fragment CommunityGuidelinesContainer_settings on Settings {
  communityGuidelines {
    enabled
    content
  }
}

fragment SuspendedInfoContainer_settings on Settings {
  organization {
    name
  }
}

fragment AnnouncementContainer_settings on Settings {
  announcement {
    id
    content
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "storyID",
            "type": "ID!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "closedAt",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isClosed",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "label",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enabled",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
    } as any), v7 = [
        (v5 /*: any*/),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "allowRegistration",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "targetFilter",
            "storageKey": null,
            "args": null,
            "concreteType": "AuthenticationTargetFilter",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "stream",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ], v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "content",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "RefreshSettingsFetchQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "settings",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "StreamContainer_settings",
                            "args": null
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "PermalinkViewContainer_settings",
                            "args": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "story",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/)
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "RefreshSettingsFetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "settings",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "reaction",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ReactionConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sortLabel",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v4 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "labelActive",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "icon",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "iconActive",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "charCount",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CharCount",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "min",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "max",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "disableCommenting",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DisableCommenting",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                (v6 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "closeCommenting",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CloseCommenting",
                            "plural": false,
                            "selections": [
                                (v6 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "auth",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Auth",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "integrations",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AuthIntegrations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "local",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "LocalAuthIntegration",
                                            "plural": false,
                                            "selections": (v7 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oidc",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OIDCAuthIntegration",
                                            "plural": false,
                                            "selections": (v7 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "google",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "GoogleAuthIntegration",
                                            "plural": false,
                                            "selections": (v7 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "facebook",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "FacebookAuthIntegration",
                                            "plural": false,
                                            "selections": (v7 /*: any*/)
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "communityGuidelines",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CommunityGuidelines",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                (v8 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "organization",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Organization",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "name",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "announcement",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Announcement",
                            "plural": false,
                            "selections": [
                                (v9 /*: any*/),
                                (v8 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "staff",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StaffConfiguration",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/)
                            ]
                        },
                        (v9 /*: any*/)
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "story",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        (v9 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "RefreshSettingsFetchQuery",
            "id": "9ace1b2766583905ae5e92d3ba62d9d1",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '84ad4ee7efe05bfd523980857cb25c67';
export default node;
